const ticket = {
  getlist: 'ticket/getlist',
  update: 'ticket/update',
  remove: 'ticket/remove',
}
export default ticket
